import { FC } from 'react';
import images from '../../assets/images';
import './CommonSearch.scss';

interface propsType {
    handleSearchDebounce: any;
    searchValue?: string | null;
    setSearchValue: any;
    from: string;
}
const CommonSearch: FC<propsType> = ({ handleSearchDebounce, searchValue, setSearchValue,  from }) => {
    const { SearchBlack } = images;

    const searchOnChange = (event: { target: { value: any; }; }) => {
        setSearchValue(event.target.value);
        if (handleSearchDebounce) {
            handleSearchDebounce(event?.target?.value);
        }
    }

    return (
        <div className="commonSearch">
            <div className={from === 'CommonChat' ? 'commonChatSearch' : 'commonSearchInputBox'}>
                <div className='commonSearchIconContainer'><img src={SearchBlack} alt='searchIcon' className='commonSearchIconStyle' /></div>
                <input id="searchBox" type='text' placeholder='Search' onChange={searchOnChange} value={searchValue || ''} className={from === 'CommonChat' ? 'commonChatSearchInputFieldStyle' : 'commonSearchInputFieldStyle'} />
            </div>
        </div>
    )
}

export default CommonSearch;